function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.998,
    height: 27.598,
    viewBox: "0 0 22.998 27.598",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16270",
    d: "M24.284 19.448a7.7 7.7 0 0 1-2.736-5.893v-3.206a8.056 8.056 0 0 0-6.9-7.957V1.15a1.15 1.15 0 1 0-2.3 0v1.242a8.055 8.055 0 0 0-6.9 7.957v3.206a7.71 7.71 0 0 1-2.746 5.9A2.012 2.012 0 0 0 4.012 23h18.974a2.012 2.012 0 0 0 1.3-3.55z",
    transform: "translate(-2)",
    style: {
      fill: "#e0e0df"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 16271",
    d: "M12.551 24.45A4.319 4.319 0 0 0 16.775 21H8.326a4.319 4.319 0 0 0 4.225 3.45z",
    transform: "translate(-1.052 3.148)",
    style: {
      fill: "#e0e0df"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.ebcd0c47609b50ad1a3c1e2e91dd92d7.svg";
export { ForwardRef as ReactComponent };